import { Activity, Clock, LogOut, PhoneForwarded, RotateCcw, Users } from "lucide-react";
import { Card, CardContent } from "../../../../../components/tailwind/card";
import { workflowTheme } from "../../../utils/workflowBuilderTheme";

function MetricCard({ icon: Icon, label, value, suffix, valueClassName, hint }) {
  return (
    <Card className={`shadow-sm wa-card-hover ${workflowTheme.card}`}>
      <CardContent className="p-4 md:p-5">
        <div className={`flex items-center gap-2 md:gap-3 mb-1 md:mb-2 ${workflowTheme.textSecondary}`}>
          <Icon className="h-3.5 w-3.5 md:h-4 md:w-4 shrink-0" />
          <h3 className="font-semibold text-xs md:text-sm truncate">{label}</h3>
        </div>
        <div className="flex items-end gap-1.5 md:gap-2 flex-wrap">
          <p className={`text-2xl md:text-3xl font-bold ${valueClassName || workflowTheme.textPrimary}`}>
            {value}
          </p>
          {suffix != null && suffix !== "" && (
            <p className={`text-xs md:text-sm mb-1 ${workflowTheme.textSecondary}`}>{suffix}</p>
          )}
        </div>
        {hint && <p className={`text-[11px] mt-1.5 ${workflowTheme.textMuted}`}>{hint}</p>}
      </CardContent>
    </Card>
  );
}

export function WorkflowAnalyticsMetrics({ metrics }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3 md:gap-4 animate-fade-in-up animate-delay-75">
      <MetricCard
        icon={Users}
        label="Started"
        value={metrics.started}
        hint="Sessions that began this month"
      />
      <MetricCard
        icon={Activity}
        label="Completed"
        value={metrics.completed}
        suffix={`(${metrics.completionRate}%)`}
        valueClassName="text-green-600 dark:text-green-400"
        hint="Reached an end node"
      />
      <MetricCard
        icon={LogOut}
        label="Abandoned"
        value={metrics.abandoned}
        suffix={`(${metrics.abandonedRate}%)`}
        valueClassName="text-red-600 dark:text-red-400"
        hint="Left before finishing"
      />
      <MetricCard
        icon={PhoneForwarded}
        label="Handoff"
        value={metrics.handoff}
        suffix={metrics.started ? `(${metrics.handoffRate}%)` : undefined}
        hint="Passed to a human agent"
      />
      <MetricCard
        icon={Clock}
        label="Avg. Duration"
        value={metrics.avgDurationLabel}
        hint="Average time for completed sessions"
      />
      <MetricCard
        icon={RotateCcw}
        label="Restarts"
        value={metrics.migratedRestart}
        hint="Sessions restarted after a version change"
      />
    </div>
  );
}
